import toast from "react-hot-toast";

// Optional per-call overrides. Most callers just pass a string; long-lived
// confirmations (e.g. "Email sent." after a slow send) can pass `duration`
// to give the user more time to register them before they auto-dismiss.
type ToastOptions = { duration?: number };

export const notify = {
  success: (message: string, opts?: ToastOptions) => {
    toast.success(message, {
      duration: opts?.duration ?? 4000,
      position: "top-right",
      style: {
        background: "#10b981",
        color: "#fff",
      },
    });
  },

  error: (message: string, opts?: ToastOptions) => {
    toast.error(message, {
      duration: opts?.duration ?? 4000,
      position: "top-right",
      style: {
        background: "#ef4444",
        color: "#fff",
      },
    });
  },

  info: (message: string) => {
    toast(message, {
      duration: 4000,
      position: "top-right",
      icon: "ℹ️",
      style: {
        background: "#3b82f6",
        color: "#fff",
      },
    });
  },

  warning: (message: string) => {
    toast(message, {
      duration: 4000,
      position: "top-right",
      icon: "⚠️",
      style: {
        background: "#f59e0b",
        color: "#fff",
      },
    });
  },

  loading: (message: string) => {
    return toast.loading(message, {
      position: "top-right",
    });
  },

  dismiss: (toastId?: string) => {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  },
};
